import { CanAccess, EditBase, Form, useEditContext } from "ra-core";
import { Navigate } from "react-router";
import { Card, CardContent } from "@/components/ui/card";

import type { Company } from "../types";
import { CompanyInputs } from "./CompanyInputs";
import { CompanyAside } from "./CompanyAside";
import { FormToolbar } from "../layout/FormToolbar";

export const CompanyEdit = () => (
  <EditBase
    actions={false}
    redirect="show"
    transform={(values) => {
      // add https:// before website if not present
      if (values.website && !values.website.startsWith("http")) {
        values.website = `https://${values.website}`;
      }
      return values;
    }}
  >
    <CompanyEditContent />
  </EditBase>
);

const CompanyEditContent = () => {
  const { isPending, record } = useEditContext<Company>();
  if (isPending || !record) return null;
  return (
    // Almikia Epic E3b (TASK-065): useEditController checks access before
    // the record is fetched, so a direct edit URL always passes a lider
    // through to a team member's edit form; the record only exists here,
    // once EditBase's RecordContext is populated, so the record-level guard
    // has to live here instead.
    <CanAccess
      resource="companies"
      action="edit"
      accessDenied={<Navigate to={`/companies/${record.id}/show`} replace />}
    >
      <div className="mt-2 flex gap-8">
        <Form className="flex flex-1 flex-col gap-4 pb-2">
          <Card>
            <CardContent>
              <CompanyInputs />
              <FormToolbar />
            </CardContent>
          </Card>
        </Form>

        <CompanyAside link="show" />
      </div>
    </CanAccess>
  );
};
